function inMobile() {
  const cWidth = document.documentElement.clientWidth;
  if (cWidth < 1000) {
    if (!["sport8"].includes(document.documentElement.getAttribute("theme"))) {
      document.getElementsByTagName("html")[0].style.fontSize =
        (document.documentElement.clientWidth / 750) * 100 + "px";
    }
  }
}
document.addEventListener("DOMContentLoaded", inMobile);
window.onresize = inMobile;



//////////////////
// WEBPACK FOOTER
// ./static/js/initRem.js
// module id = UQhB
// module chunks = 0